import LogoHeaderImage from '../../images/on-the-copy.png';

const LogoHeader: React.FC = () => (
  <div className="logo-copy">
    <img src={LogoHeaderImage} alt="" className="img-fluid" />
  </div>
);

export default LogoHeader;
